module.exports = __webpack_public_path__ + "img/功能对比.3a1fbcdd.svg";